import { UI } from '@genial/components';
import { Color } from '@genial/design-tokens';
import { Modal, ScrollView } from 'native-base';
import { Dimensions } from 'react-native';
import { useRecoilValue } from 'recoil';

import { useFixedIncomeAssetContext } from '../../../../../../../../BatchTicket/components/DynamicAsset/contexts/products/FixedIncome';
import { useGlobalProductContext } from '../../../../../contexts';

import { formatFixedIncomeDetailsData } from './constants';

export const ItemDetails = () => {
  const { height } = Dimensions.get('window');

  const { product } = useGlobalProductContext();

  const { modalOpen, offerSelected, setModalOpen } = useFixedIncomeAssetContext();

  const marketStatus = useRecoilValue(product.marketStatusSelector);

  if (!offerSelected) {
    return <></>;
  }

  const getOfferCaptions = () => {
    return product.captions
      .filter(({ icon }) => offerSelected.captions.includes(icon))
      .map((caption) => ({ ...caption, iconColor: Color[caption.iconColor] }));
  };

  return (
    <UI.Modal isOpen={modalOpen} onClose={() => setModalOpen(false)} testId="modal-details">
      <Modal.Content
        alignItems={'center'}
        w={'full'}
        maxH={{ base: height * 0.75, lg: 'full' }}
        maxW={{ base: 'full', lg: '631px' }}
        marginBottom={{ base: 0, lg: 'none' }}
        marginTop={{ base: 'auto', lg: 0 }}>
        <ScrollView w={'full'} showsVerticalScrollIndicator={false}>
          <UI.ModalDetails
            testId="modal-details"
            captions={getOfferCaptions()}
            data={formatFixedIncomeDetailsData(offerSelected) as any}
            title={offerSelected.productDisplayNormalized}
            initials={offerSelected.suitabilityProfileAcronym || ''}
            marketStatus={marketStatus.message}
            isMarketClosed={!marketStatus.isOpen}
            onClose={() => setModalOpen(false)}
          />
        </ScrollView>
      </Modal.Content>
    </UI.Modal>
  );
};
